// extracted by css-extract-rspack-plugin
export default {"loadMore":"JdclicIXVOU_ND2E"};